export default __webpack_public_path__ + "static/placeholder-4-3-portrait-673582b1f2facc4e9da6a60c460295ca.png";